import React, { useMemo, Fragment } from 'react';
import Head from 'next/head';
import { initSravniTM } from '@sravni/utils/lib/analytics';
import { useAbTestingSdk } from '@sravni/react-utils';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var CDN = 'https://s91588.cdn.ngenix.net';
var PRECONNECTED_DOMAINS = [CDN];
var SRAVNI_PRECONNECTED_DOMAINS = [
    'https://www.googletagmanager.com',
    'https://www.google-analytics.com',
    'https://mc.yandex.ru',
    'https://www.gstatic.com',
];
var PRELOAD_FONTS = [
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-light.woff2",
        type: "font/woff2"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-light.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-regular.woff2",
        type: "font/woff2"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-regular.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-semibold.woff2",
        type: "font/woff2"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-semibold.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-bold.woff2",
        type: "font/woff2"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-bold.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/aeroport/Aeroport-bold.woff2",
        type: "font/woff2"
    },
    {
        url: CDN + "/shared/static/fonts/aeroport/Aeroport-bold.woff",
        type: "font/woff"
    },
];
var PRELOAD_OLD_FONTS = [
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-regular.eot",
        type: "font/eot"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-regular.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-regular.ttf",
        type: "font/ttf"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-regular.svg",
        type: "font/svg"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-light.eot",
        type: "font/eot"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-light.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-light.ttf",
        type: "font/ttf"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-light.svg",
        type: "font/svg"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-semibold.woff2",
        type: "font/woff2"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-semibold.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-extrabold.eot",
        type: "font/eot"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-extrabold.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-extrabold.ttf",
        type: "font/ttf"
    },
    {
        url: CDN + "/shared/static/fonts/open-sans/opensans-extrabold.svg",
        type: "font/svg"
    },
    {
        url: CDN + "/shared/static/fonts/pt-sans/pt-sans-currencys-bold.eot",
        type: "font/eot"
    },
    {
        url: CDN + "/shared/static/fonts/pt-sans/pt-sans-currencys-bold.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/pt-sans/pt-sans-currencys-bold.ttf",
        type: "font/ttf"
    },
    {
        url: CDN + "/shared/static/fonts/pt-sans/pt-sans-currencys-bold.svg",
        type: "font/svg"
    },
    {
        url: CDN + "/shared/static/fonts/ubuntu/ubuntu-bold.eot",
        type: "font/eot"
    },
    {
        url: CDN + "/shared/static/fonts/ubuntu/ubuntu-bold.woff",
        type: "font/woff"
    },
    {
        url: CDN + "/shared/static/fonts/ubuntu/ubuntu-bold.ttf",
        type: "font/ttf"
    },
    {
        url: CDN + "/shared/static/fonts/ubuntu/ubuntu-bold.svg",
        type: "font/svg"
    },
];

var decorateAnalyticsOptions = function (options, helpers) {
    if (!options)
        return undefined;
    var abTestingSdk = helpers.abTestingSdk;
    var abTestingStatistics = abTestingSdk ? abTestingSdk.getAnalyticsStatistics() : undefined;
    return __assign(__assign({}, options), (abTestingStatistics ? { abTestingStatistics: abTestingStatistics } : {}));
};
/**
 * @description CommonHead component.
 *
 * @component
 * @example
 * ```jsx
 * <CommonHead>content</CommonHead>
 * ```
 */
var CommonHead = function (props) {
    var _a;
    var children = props.children, _b = props.preconnectedDomains, preconnectedDomainsOutside = _b === void 0 ? [] : _b, _c = props.preloadedFonts, preloadedFontsOutside = _c === void 0 ? [] : _c, sravniTMOptionsOutside = props.sravniTMOptions, analyticsOptionsOutside = props.analyticsOptions, _d = props.designSystem, designSystem = _d === void 0 ? 'new' : _d;
    var abTestingSdk = useAbTestingSdk();
    var analyticsOptions = decorateAnalyticsOptions((_a = analyticsOptionsOutside !== null && analyticsOptionsOutside !== void 0 ? analyticsOptionsOutside : sravniTMOptionsOutside) !== null && _a !== void 0 ? _a : undefined, {
        abTestingSdk: abTestingSdk
    });
    var isAnalyticsEnabled = analyticsOptions && analyticsOptions.enabled;
    var preconnectedDomains = useMemo(function () { return __spreadArray(__spreadArray(__spreadArray([], __read(PRECONNECTED_DOMAINS)), __read((isAnalyticsEnabled ? SRAVNI_PRECONNECTED_DOMAINS : []))), __read(preconnectedDomainsOutside)); }, [isAnalyticsEnabled, preconnectedDomainsOutside]);
    var preloadedFonts = useMemo(function () { return __spreadArray(__spreadArray(__spreadArray([], __read((['new', 'all'].includes(designSystem) ? PRELOAD_FONTS : []))), __read((['old', 'all'].includes(designSystem) ? PRELOAD_OLD_FONTS : []))), __read(preloadedFontsOutside)); }, [preloadedFontsOutside, designSystem]);
    return (React.createElement(Head, null,
        React.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1, shrink-to-fit=no" }),
        React.createElement("meta", { httpEquiv: "X-UA-Compatible", content: "IE=edge" }),
        React.createElement("meta", { name: "mobile-web-app-capable", content: "yes" }),
        preconnectedDomains.map(function (domain) { return (React.createElement(Fragment, { key: domain },
            React.createElement("link", { rel: "preconnect", href: domain }),
            React.createElement("link", { rel: "dns-prefetch", href: domain }))); }),
        React.createElement("link", { rel: "manifest", href: CDN + "/shared/static/manifest.json" }),
        React.createElement("link", { rel: "icon", href: CDN + "/shared/static/favicon.ico" }),
        React.createElement("link", { rel: "icon", href: CDN + "/shared/static/favicon.png", type: "image/png", sizes: "32x32" }),
        React.createElement("link", { rel: "icon", href: CDN + "/shared/static/favicon.svg", type: "image/svg+xml" }),
        React.createElement("link", { rel: "apple-touch-icon", href: CDN + "/shared/static/apple-touch-icon-57x57.png" }),
        React.createElement("link", { rel: "apple-touch-icon", sizes: "72x72", href: CDN + "/shared/static/apple-touch-icon-72x72.png" }),
        React.createElement("link", { rel: "apple-touch-icon", sizes: "114x114", href: CDN + "/shared/static/apple-touch-icon-114x114.png" }),
        React.createElement("link", { rel: "icon", type: "image/png", sizes: "192x192", href: CDN + "/shared/static/android-icon-192x192.png" }),
        preloadedFonts.map(function (font) { return (React.createElement("link", { rel: "preload", href: font.url, as: "font", type: font.type, crossOrigin: "anonymous", key: font.url, 
            //@ts-ignore
            fetchpriority: "hight" })); }),
        ['old', 'all'].includes(designSystem) ? (React.createElement("script", { defer: true, dangerouslySetInnerHTML: {
                __html: 'window.SC_DISABLE_SPEEDY = false;'
            } })) : null,
        isAnalyticsEnabled && analyticsOptions && (React.createElement("script", { id: 'analytics-initialization', dangerouslySetInnerHTML: { __html: initSravniTM(analyticsOptions) } })),
        children));
};

export { CommonHead };
//# sourceMappingURL=index.esm.js.map
